// removed by extract-text-webpack-plugin
module.exports = {"hours-container":"HoursSection__hours-container___IG-wt","hours-title":"HoursSection__hours-title___3tkND","hours-item":"HoursSection__hours-item___hd6zK"};